import z from 'zod';
export const CASE_STATUS_OPEN = 'open';
export const CASE_STATUS_CLOSED = 'closed';
export const CASE_STATUSES = [
    CASE_STATUS_OPEN,
    CASE_STATUS_CLOSED,
];
export const caseStatusValue = z.enum(CASE_STATUSES);
export const caseStatus = (value) => caseStatusValue.parse(value);
export const isCaseStatus = (value) => caseStatusValue.safeParse(value).success;
export const isCaseStatusOpen = (status) => status === CASE_STATUS_OPEN;
export const isCaseStatusClosed = (status) => status === CASE_STATUS_CLOSED;
//# sourceMappingURL=case-status.js.map